<div class="modal-header">
    <h2 class="modal-title">{{'request.partnerFilterPopup.title' | translate}}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModalHandler()">
    </button>
</div>

<div class="modal-body">
    <kendo-multiselect HJSuppress
        class="custom-kendo-control-xl"
        fillMode="flat"
        [rounded]="roundedLarge"
        [size]="sizeLarge"
        name="partnersName"
        #partnersName="ngModel" 
        valueField="partnerId"
        textField="name"
        [filterable]="true"
        [data]="partnerDataSource"
        placeholder="{{'users.companySearchPlaceholder' | translate}}"
        [clearButton]="false"
        [(ngModel)]="requestModalFilters.partners"
        (filterChange)="filterDataSourceHandler($event)"
        [popupSettings]="{popupClass : 'data-hj-suppress'}"
    >
        <ng-template kendoPrefixTemplate>
            <i class="app-icon icon icon-search icon-xxl"></i>
        </ng-template>
        <ng-template kendoAutoCompleteItemTemplate let-dataItem>
            <div class="autocomplete-template-container">
                <span class="autocomplete-main-label">{{dataItem?.name}}</span>
                <span class="autocomplete-second-label" *ngIf="dataItem.uniqueIdentifier">{{'users.cui' | translate}}: {{dataItem?.uniqueIdentifier}}</span>
                <span class="autocomplete-second-label" *ngIf="!dataItem.uniqueIdentifier">{{'users.code' | translate}}: {{dataItem?.code}}</span>
            </div>
        </ng-template>
        <ng-template kendoAutoCompleteNoDataTemplate>
            <span *ngIf="partnerSearchValue?.length < 3">{{'users.searchPartnerInfo' | translate}}</span>
            <span *ngIf="partnerSearchValue?.length >= 3 && !hasPartners">{{'common.noData' | translate}}</span>
        </ng-template>
    </kendo-multiselect>

    <div class="selected-partners-container">
        <div *ngFor="let partner of requestModalFilters.partners; let indexPartner = index" class="selected-partner">
            <span HJSuppress class="partner-name">{{partner.name}}</span>
            <button class="btn delete-x-btn" (click)="removeSelectedPartner(partner.partnerId)">
                <i class="app-icon icon icon-close"></i>
            </button>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn link-btn" (click)="resetHandler()">
        <i class="app-icon icon icon-reload icon-lg me-2"></i> 
        {{'request.filterPopup.reset' | translate}}
    </button>
    <button class="btn primary-btn" (click)="applyFilterHandler()">
        {{'request.filterPopup.apply' | translate}}
    </button>
</div>
